import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { apiPluginRuleActionValues } from '@api/@types';
import { LegacyFeatureType } from '@modules/ide-provisioner/plugins-rules/plugin-rules-bundle-dialog/legacy-feature-type';
import { useFeatureFlag, useServerConfigContext } from '@common/server-config-context/server-config-context';
import { ActionSelector } from '../../common/action-selector/action-selector';
import { VersionSelector } from './version-selector/version-selector';
import styles from './marketplace-plugin-content.css';
export function MarketplacePluginContent(props) {
    const { className, pluginRuleType, rule, onRuleChange, legacyFeatureType } = props;
    const serverConfig = useServerConfigContext();
    const cloudModeEnabled = serverConfig.isCloud();
    const allowDenyPluginsListEnabled = useFeatureFlag('allowDenyPluginsListEnabled');
    const { version } = pluginRuleType;
    const isActionAllowed = useCallback((action, version) => {
        if (!allowDenyPluginsListEnabled) {
            if (legacyFeatureType === LegacyFeatureType.DisabledPlugins) {
                switch (action) {
                    case 'force-restrict':
                    case 'disable':
                        return true;
                    default:
                        return false;
                }
            }
            if (legacyFeatureType === LegacyFeatureType.AutoInstallPlugins) {
                switch (action) {
                    case 'force-auto-install':
                    case 'auto-install':
                        return true;
                    default:
                        return false;
                }
            }
        }
        switch (action) {
            case 'auto-install':
            case 'force-auto-install':
                return !cloudModeEnabled && (version === null || version === void 0 ? void 0 : version.type) !== 'all';
            case 'allow':
            case 'disable':
            case 'force-restrict':
            case 'restrict':
                return (version === null || version === void 0 ? void 0 : version.type) !== 'latest';
            default:
                if (action === undefined) {
                    return false;
                }
                return assert_exhaustive(action);
        }
    }, [cloudModeEnabled, allowDenyPluginsListEnabled, legacyFeatureType]);
    const allowedActions = useMemo(() => apiPluginRuleActionValues.reduce((acc, action) => {
        acc[action] = isActionAllowed(action, version);
        return acc;
    }, {}), [isActionAllowed, version]);
    const handleVersionChange = useCallback((version) => {
        onRuleChange({
            ...rule,
            singlePluginTypeRule: { ...pluginRuleType, version },
            action: isActionAllowed(rule.action, version) ? rule.action : undefined
        });
    }, [isActionAllowed, onRuleChange, rule, pluginRuleType]);
    const handleActionChange = useCallback((action) => onRuleChange({ ...rule, action }), [onRuleChange, rule]);
    return (_jsxs("div", { className: classNames(styles.wrapper, className), children: [(allowDenyPluginsListEnabled ||
                legacyFeatureType === LegacyFeatureType.AutoInstallPlugins) && (_jsx(VersionSelector, { version: pluginRuleType === null || pluginRuleType === void 0 ? void 0 : pluginRuleType.version, onVersionChange: handleVersionChange })), _jsx(ActionSelector, { className: styles.actionSelector, action: rule.action, onActionChange: handleActionChange, allowedActions: allowedActions })] }));
}
